module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"summary":{"total":"您有 {0} 笔 {1} 的","description":"未付款订单。","hint":"（ 截至 {0} ）"},"order":{"code":"订单号：{0}","created_at":"下单时间：{0}","bank_account":"{0} {1} {2}","sender_name":"（汇款人：{0}）","copy_bank_account_no":"复制银行账号"}}}')
  delete Component.options._Ctor
}
